import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/useAuth";
import { useUser } from "../../contexts/useUserData";
import { useChat } from "../../contexts/useChatData";
import { verifyToken } from "../../scripts/token";


const Login = () => {
    const navigate = useNavigate();
    const { login, loadedToken, errorTokenLogin, putErrorTokenMessage } = useAuth();
    const { pushUser, pushToken, pushUserName, pushSeccion, pushScope, pushPindi, pushSalesMediaName, pushUserDepartment, pushOrigin, pushPriorityGroups, pushLoginMethod } = useUser();
    const { putLinkToken } = useChat();
    const location = useLocation();
    const token = new URLSearchParams(location.search).get("token");

    useEffect(() => {
        async function extractDataToken(token: string) {
            try {
                const response = await verifyToken(token);
                if (response.login) {
                    pushUser?.(response.user);
                    pushUserName?.(response.userName);
                    pushScope?.(response.scope);
                    pushSeccion?.(response.seccion);
                    pushToken?.(response.token);
                    if (response.priorityGroups) pushPriorityGroups?.(response.priorityGroups);
                    putLinkToken?.(response.origin);
                    pushPindi?.(response.pindi);
                    pushSalesMediaName?.(response.salesMediaName);
                    pushUserDepartment?.(response.userDepartment);
                    pushOrigin?.(response.origin);
                    pushLoginMethod?.("token");
                    login?.();
                    loadedToken?.();
                    navigate("/chat");
                } else if (response.errorTokenLogin) {
                    putErrorTokenMessage?.(response.errorTokenMessage);
                    pushToken?.("");
                    errorTokenLogin?.(true);
                    loadedToken?.();
                }
            } catch (e) {
                putErrorTokenMessage?.("ERROR TOKEN");
                errorTokenLogin?.(true);
                loadedToken?.();
            }
        }
        if (token) {
            extractDataToken(token);
        } else {
            errorTokenLogin?.(true);
            putErrorTokenMessage?.("Acceso denegado. Accede a la aplicación desde el portal corporativo.");
            loadedToken?.();
        }
    }, [token]);
    return null;
};

export default Login;
